import { type Locale } from '@/app/lib/localization/types';

import { type Game, type GameOrientation } from '@/shared/api/game/types';
import { type DecodedToken } from '@/shared/api/types';
import { type UserProfile } from '@/shared/api/user/types';

export enum ThemeMode {
  DARK = 'dark',
  LIGHT = 'light',
}

export interface AppStateActions {
  hydrate: (fresh: ((state: AppState) => Partial<AppState>) | Partial<AppState>) => void;
  reset: (state: AppState) => void;
  loadGame: (token: DecodedToken) => Promise<void>;
  fetchUserProfile: () => Promise<void>;
  markNoAdPurchased: () => void;
  setIsWebMode: (value: boolean) => void;
  setIsLiteMode: (value: boolean) => void;
  setScreenOrientation: (orientation: GameOrientation) => void;
  setIsExclusiveMode: (value: boolean) => void;
}

export interface AppState {
  game: Game | null;
  userProfile: UserProfile | undefined;
  isGameLoading: boolean;
  token: string;
  sessionId: string;
  decodedToken: DecodedToken | null;
  gameUrl: string | null;
  theme: ThemeMode;
  actions: AppStateActions;
  lang: Locale;
  startAppArgs: StartAppArgs;
  // the developer's link, which can be obtained in the admin panel, gives access to some functionality.
  // For example, the "open in browser" button and the connection eruda
  showDevMenu: boolean;
  wsSentInitialMsg: boolean;
  messages: Record<string, string>;
  isWebMode: boolean;
  isLiteMode: boolean;
  screenOrientation: GameOrientation;
  isExclusiveMode: boolean;
  pdTma: string | null;
}

export enum UIKit {
  APPLE = 'apple',
  MATERIAL = 'material',
}

export type InitialState = Omit<AppState, 'actions' | 'game' | 'isGameLoading'>;

export interface StartAppArgs {
  game?: GameParams;
  labels?: string[];
  src?: string;
  path?: string | null;
  backPathname?: string;
  type?: 'market' | 'game';
  locale?: string;
  pdHideUI?: boolean;
  pdTma?: string;
}

export interface GameParams {
  name: string;
  key: string;
  raw: Record<string, any>;
}
